import React, { useEffect, useState } from "react";
import { useSelector, useDispatch } from "react-redux";
import { useParams } from "react-router-dom";
import { showModal } from "../../../../store/slices/modal";

const DisputeRequest = ({ disputeDetail }) => {
  const dispatch = useDispatch();
  const { orderId } = useParams();
  const disputeData = useSelector((state) => state.Dispute);
  const [userType, setUserType] = useState("");
  const [disputeTypeName, setDisputeTypeName] = useState("");

  useEffect(() => {
    disputeData.singleDisputObj?.disputer_user_type === "shipper"
      ? setUserType("Shipper")
      : setUserType("Carrier");
    disputeData.singleDisputObj?.disputer_user_type === "cancel_order"
      ? setDisputeTypeName("Cancel")
      : setDisputeTypeName("Finished");
  }, [disputeData.singleDisputObj?.dispute_type]);

  const openLoadManageModal = (e) => {
    dispatch(
      showModal({
        modalName: "CreateDisputeRequest",
        modalData: { id: orderId },
      })
    );
  };

  const openWithdrawDisputeModal = (e) => {
    dispatch(
      showModal({
        modalName: "WithdrawDisputeRequest",
        modalData: { disputeId: disputeDetail.id },
      })
    );
  };

  const openAgreeDisputeModal = (e) => {
    dispatch(
      showModal({
        modalName: "OtherPartyAgree",
        modalData: { disputeId: disputeDetail.id },
      })
    );
  };

  const openDisgreeDisputeModal = (e) => {
    dispatch(
      showModal({
        modalName: "OtherPartyDisagree",
        modalData: { disputeId: "1" },
      })
    );
  };

  return (
    <>
      <section className="loads-details-alerts">
        <div className="container theme-section">
          <p className="large-text">
            {userType} want to {disputeTypeName} the order
          </p>

          {Object.keys(disputeData.singleDisputObj).length !== 0 &&
            disputeData.singleDisputObj?.reason_of_dispute != null && (
              <div className="dispute-respons mt-3">
                <label>Reason Of Dispute:</label>
                <p>{disputeData.singleDisputObj?.reason_of_dispute}</p>
              </div>
            )}

          {Object.keys(disputeData.singleDisputObj).length !== 0 &&
            disputeData.singleDisputObj?.reason_of_other_party_disagree !=
              null && (
              <div className="dispute-respons mt-3">
                <label>Reason Of Disagree:</label>
                <p>
                  {disputeData.singleDisputObj?.reason_of_other_party_disagree}
                </p>
              </div>
            )}

          {Object.keys(disputeData.singleDisputObj).length !== 0 &&
            disputeData.singleDisputObj?.reason_of_admin != null && (
              <div className="dispute-respons mt-3">
                <label>Reason Of Admin:</label>
                <p>{disputeData.singleDisputObj?.reason_of_admin}</p>
              </div>
            )}

          {Object.keys(disputeData.singleDisputObj).length !== 0 &&
            !["", null, undefined].includes(disputeData.singleDisputObj?.reason_of_withdraw) && (
              <div className="dispute-respons mt-3">
                <label>Reason Of Withdraw:</label>
                <p>{disputeData.singleDisputObj?.reason_of_withdraw}</p>
              </div>
            )}

          {disputeData.singleDisputObj.can_give_feedback === true && (
            <div className="multiple-btn flex-direction-initial mt-4 flex-wrap">
              <button className="m-0" onClick={openAgreeDisputeModal}>
                Agree
              </button>
              <button className="m-0" onClick={openDisgreeDisputeModal}>
                Disagree
              </button>
            </div>
          )}

          {disputeData.canSeeWithdrawButton === true && (
            <div className="multiple-btn flex-direction-initial mt-4 flex-wrap">
              <button className="m-0" onClick={openWithdrawDisputeModal}>
                Withdraw Dispute request{" "}
              </button>
            </div>
          )}

          {disputeData.canSeeDisputButton === true && (
            <div className="multiple-btn flex-direction-initial mt-4 flex-wrap">
              <button className="m-0" onClick={openLoadManageModal}>
                Make Dispute request{" "}
              </button>
            </div>
          )}
        </div>
      </section>
    </>
  );
};

export default DisputeRequest;
